import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {errorRaised} from "@mnjsplatform/data/lib/actions/errorActions";
import PrivateDocument from "./PrivateDocument";
import OldPrivateDocument from "../PrivateDocuments/OldPrivateDocument";
import SalaryRequestList from "../SalaryProject/SalaryRequestList";

class PrivateDocuments extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            isDataReady: false
        }
    }

    componentDidMount() {
        this.setState({isDataReady: false}, this.initialize);
    }

    async initialize() {
        try {
            await this.props.dispatch(this.props.DocumentTypes_List.reset());
            await this.props.dispatch(this.props.DocumentTypes_List.execute({}, {
                withParams: false,
                newItem: true
            }));
            this.documentTypes = this.props.DocumentTypes_List.dataTable().filter(t => t["IsView"] === 1)/*.sort((a, b) => a.OrderPos - b.OrderPos)*/;
        } catch (e) {
            this.props.dispatch(errorRaised(e));
        } finally {
            this.setState({isDataReady: true});
        }
    }

    render() {
        if (!this.state.isDataReady)
            return null;

        const header = this.props.DocumentTypes_List.getFieldInfo('AllowAdd').Header;
        return (<>
            {
             this.documentTypes.map((row, index) => {
                    if (row.ClaimPDTypeId === "SalProject") {
                        return <SalaryRequestList key={row.ClaimPDTypeId} row={row} />
                    } else if (row?.FrameType === 2) {
                        return <OldPrivateDocument key={row.ClaimPDTypeId} row={row}/>
                    } else {
                        return <PrivateDocument key={row.ClaimPDTypeId} row={row}
                                                headerAllowAdd={header}/>
                    }
                })
            }
        </>)
    }
}
PrivateDocuments.propTypes = {
    dispatch: PropTypes.func.isRequired,
    DocumentTypes_List: PropTypes.object
}
PrivateDocuments.defaultProps = {};
function mapStateToProps(state, ownProps) {
    return {
        DocumentTypes_List: state.privateDocumentsState.DocumentTypes_List
    }
}
export default connect(mapStateToProps)(PrivateDocuments)